import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/login.vue'
import home from '../components/home.vue'
import Forbidden from '../components/Forbidden.vue'

Vue.use(VueRouter)

// 公共路由 - 所有用户可访问
const publicRoutes = [
  { path: '/index', component: () => import('../components/homeIndex.vue'), meta: { title: '管理中心' } },
  { path: '/Invoice/UploadInvoice', component: () => import('../components/Invoice/UploadInvoice.vue'), meta: { title: '票据上传' } },
  { path: '/Invoice/OutpatientInvoiceDetails', component: () => import('../components/Invoice/OutpatientInvoiceDetails.vue'), meta: { title: '我的票夹-门诊票据' } },
  { path: '/Invoice/InpatientInvoiceDetails', component: () => import('../components/Invoice/InpatientInvoiceDetails.vue'), meta: { title: '我的票夹-住院票据' } },
  { path: '/sysnotice', component: () => import('../components/info/sysnotice.vue'), meta: { title: '系统公告-管理中心' } },
  { path: '/message', component: () => import('../components/info/message.vue'), meta: { title: '我的消息-管理中心' } },
  { path: '/make/Detail', component: () => import('../components/make/det.vue'), meta: { title: '预约详情-管理中心' } }
]

// 管理员路由 - 仅 is_superuser=true 可访问
const adminRoutes = [
  { path: '/makeReview', component: () => import('../components/make/makeReview.vue'), meta: { 
    title: '预约审批-管理中心',
    requiresAdmin: true 
  }},
  { path: '/Invoice/ReviewOutpatientInvoice', component: () => import('../components/Invoice/ReviewOutpatientInvoice.vue'), meta: { 
    title: '门诊票据审批-管理中心',
    requiresAdmin: true 
  }},
  { path: '/Invoice/ReviewInpatientInvoice', component: () => import('../components/Invoice/ReviewInpatientInvoice.vue'), meta: { 
    title: '住院票据审批-管理中心',
    requiresAdmin: true
  }},
  { path: '/Invoice/OutpatientInvoiceCases', component: () => import('../components/Invoice/OutpatientInvoiceCases.vue'), meta: { 
    title: '门诊票据审批-管理中心',
    requiresHrOrFinOrAdmin: true
  }},
  { path: '/Invoice/InpatientInvoiceCases', component: () => import('../components/Invoice/InpatientInvoiceCases.vue'), meta: { 
    title: '住院票据审批-管理中心',
    requiresHrOrFinOrAdmin: true
  }},
  { path: '/Invoice/OutpatientInvoiceOverview', component: () => import('../components/overview/OutpatientInvoiceOverview.vue'), meta: { 
    title: '住院票据总览-管理中心',
    requiresHrOrFinOrAdmin: true
  }},
  { path: '/Invoice/InpatientInvoiceOverview', component: () => import('../components/overview/InpatientInvoiceOverview.vue'), meta: { 
    title: '住院票据总览-管理中心',
    requiresHrOrFinOrAdmin: true
  }},
  { path: '/Invoice/OutpatientCasesOverview', component: () => import('../components/overview/OutpatientCasesOverview.vue'), meta: { 
    title: '门诊CASE总览-管理中心',
    requiresHrOrFinOrAdmin: true
  }},
  //{ path: '/Invoice/InpatientCasesOverview', component: () => import('../components/overview/InpatientCasesOverview.vue'), meta: { 
  //  title: '住院CASE总览-管理中心',
  //  requiresHrOrFinOrAdmin: true
  //}},
  { path: '/Invoice/AnnualReportOverview', component: () => import('../components/overview/AnnualReportOverview.vue'), meta: { 
    title: '年度报表总览-管理中心',
    requiresHrOrFinOrAdmin: true
  }},
  { path: '/Invoice/AnnualReport', component: () => import('../components/Invoice/AnnualReport.vue'), meta: { 
    title: '年度报表-管理中心',
    requiresHrOrAdmin: true
  }},
  { path: '/InstrumentSchedules', component: () => import('../components/make/InstrumentSchedules.vue'), meta: { 
    title: '仪器排班-管理中心',
    requiresAdmin: true 
  }},
  { path: '/set/setPass', component: () => import('../components/set/modPass.vue'), meta: { 
    title: '信息修改-管理中心',
    requiresAdmin: true 
  }},
  { path: '/set/addAdmin', component: () => import('../components/set/addAdmin.vue'), meta: { 
    title: '添加管理员-管理中心',
    requiresAdmin: true 
  }},
  { path: '/dep/hospital', component: () => import('../components/dep/hospital.vue'), meta: { 
    title: '分院管理-管理中心',
    requiresAdmin: true 
  }},
  { path: '/dep/depOne', component: () => import('../components/dep/depOne.vue'), meta: { 
    title: '一级科室管理-管理中心',
    requiresAdmin: true 
  }},
  { path: '/dep/depTwo', component: () => import('../components/dep/depTwo.vue'), meta: { 
    title: '二级科室管理-管理中心',
    requiresAdmin: true 
  }},
  { path: '/dep/doctor', component: () => import('../components/dep/doctor.vue'), meta: { 
    title: '医生管理-管理中心',
    requiresAdmin: true 
  }},
  { path: '/users/userlist', component: () => import('../components/users/user.vue'), meta: { 
    title: '用户管理-管理中心',
    requiresHrOrAdmin: true 
  }},
  { path: '/users/approvalsrelations', component: () => import('../components/users/approvalsrelations.vue'), meta: { 
    title: '审批关系-管理中心',
    requiresHrOrAdmin: true 
  }},
  { path: '/systemInfo/swiper', component: () => import('../components/info/swiper.vue'), meta: { 
    title: '轮播图管理-管理中心',
    requiresAdmin: true 
  }},
  { path: '/systemInfo/notice', component: () => import('../components/info/notice.vue'), meta: { 
    title: '公告发布-管理中心',
    requiresAdmin: true 
  }}
]

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: Login, meta: { title: '登录-管理中心', public: true } },
  { path: '/forbidden', component: Forbidden, meta: { title: '无权限访问', public: true } },
  {
    path: '/home', 
    component: home, 
    meta: { title: '管理中心' }, 
    redirect: '/index', 
    children: [
      ...publicRoutes,
      ...adminRoutes,
      { path: '/404', component: () => import('../components/404.vue'), meta: { title: '404-页面走丢了-管理中心', public: true } },
    ]
  },
  { path: '*', redirect: '/404' },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 公共页面直接放行
  if (to.meta.public) {
    return next()
  }

  // 检查登录状态
  const token = localStorage.getItem('adminToken')
  const time = Number(localStorage.getItem('tokenStartTime'))
  const isTokenValid = token && time + (7 * 24 * 60 * 60) - (60 * 60) > Math.round(new Date().getTime() / 1000)

  // 处理登录页
  if (to.path === '/login') {
    if (isTokenValid) {
      return next('/home')
    }
    return next()
  }

  // 检查是否登录
  if (!isTokenValid) {
    return next('/login')
  }

  // 检查管理员权限
  const isSuperuser = localStorage.getItem('isSuperuser') === 'true'
  const isStaff = localStorage.getItem('isStaff') === 'true'
  const isHrAudit = localStorage.getItem('isHrAudit') === 'true'
  const isFinAudit = localStorage.getItem('isFinAudit') === 'true'
  // 1. 验证 "HR/财务/管理员" 可访问的路由
  if (to.meta.requiresHrOrFinOrAdmin) {
    if (!isStaff && !isSuperuser && !isHrAudit && !isFinAudit) {
      return next('/forbidden')
    }
  }

  // 2. 验证 "HR/管理员" 可访问的路由
  if (to.meta.requiresHrOrAdmin) {
    if (!isStaff && !isSuperuser && !isHrAudit) {
      return next('/forbidden')
    }
  }

  // 3. 验证 "仅管理员" 可访问的路由（原逻辑）
  if (to.meta.requiresAdmin && !isSuperuser && !isStaff) {
    return next('/forbidden')
  }

  next()
})

export default router